module.exports = new __parcel__URL__("Mageskill_18.7b724f63.png").toString();